import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { UserAdminState } from '@modules/administration/models/user-admin-state.enum';
import { TuiBadge, TuiStatus } from '@taiga-ui/kit';

@Component({
  selector: 'pxc-user-admin-state-badge',
  imports: [TuiBadge, TuiStatus, TranslocoDirective],
  templateUrl: './user-admin-state-badge.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserAdminStateBadgeComponent {
  @Input() state: UserAdminState;
  @Input() count?: number;

  UserState = UserAdminState;
}
